export const NEW_CONTENT_ID = "new";

export const ErrorTypes = {
  serverError: "serverError",
  validationError: "validationError",
};
